import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { createHoliday } from '../../services/api';

const HolidayAddModal = ({ show, onHide, onSuccess, selectedYear }) => {
    const [formData, setFormData] = useState({
        name: '',
        date: '',
        type: 'fixed',
        isHalfDay: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Reset form when modal opens
    useEffect(() => {
        if (show) {
            const currentYearDate = `${selectedYear}-01-01`;
            setFormData({
                name: '',
                date: currentYearDate,
                type: 'fixed',
                isHalfDay: false
            });
            setError('');
        }
    }, [show, selectedYear]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);
            setError('');

            const response = await createHoliday(formData);
            if (response.success) {
                onSuccess('Tatil başarıyla eklendi');
                onHide();
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Tatil eklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>🎉 Yeni Tatil Ekle</Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}

                    {/* Tatil Adı */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tatil Adı *</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            value={formData.name}
                            onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                            placeholder="Örn: Şirket Kuruluş Günü"
                        />
                    </Form.Group>

                    {/* Tarih */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tarih *</Form.Label>
                        <Form.Control
                            type="date"
                            required
                            value={formData.date}
                            onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
                        />
                    </Form.Group>

                    {/* Tatil Tipi */}
                    <Form.Group className="mb-3">
                        <Form.Label>Tatil Tipi</Form.Label>
                        <Form.Select
                            value={formData.type}
                            onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
                        >
                            <option value="fixed">Sabit Tatil</option>
                            <option value="religious">Dini Tatil</option>
                            <option value="half_day">Yarım Gün Tatil</option>
                        </Form.Select>
                    </Form.Group>

                    {/* Yarım Gün Seçeneği */}
                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Yarım gün tatil"
                            checked={formData.isHalfDay}
                            onChange={(e) => setFormData(prev => ({ ...prev, isHalfDay: e.target.checked }))}
                        />
                        <Form.Text className="text-muted">
                            Bu seçenek working days hesaplamasını etkileyebilir
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={loading}>
                        İptal
                    </Button>
                    <Button type="submit" variant="primary" disabled={loading}>
                        {loading ? 'Ekleniyor...' : '🎉 Tatil Ekle'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default HolidayAddModal;